import { frontendURL } from '../../../helper/URLHelper';
import CrmIndex from './pages/CrmIndex.vue';
import CrmReport from './pages/CrmReport.vue';
import CrmAgenda from './pages/CrmAgenda.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_index',
    component: CrmIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/crm/report'),
    name: 'crm_report',
    component: CrmReport,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/crm/agenda'),
    name: 'crm_agenda',
    component: CrmAgenda,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
